//#region  imports
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useScreenSize } from "../../../utils/media-query.js";
import BaseFormWithBreadCrumbs from "../../../components/base-form/base-form.js";
import Form, { GroupItem, Item, Label, RequiredRule, SimpleItem } from "devextreme-react/form";
import { useDataSource } from "../../../contexts/dataSource.js";
import { useAuth } from "../../../contexts/auth.js";
import useAxiosPrivate, { axiosHrPrivate } from "../../../api/useAxios.js";
import { leaveCalculationMethods, leaveStatusTypes } from "../../../utils/lookup-groups.ts";
import { getSelectBoxPropertiesIdText, getSelectBoxPropertiesIdName } from "../../../utils/default-props.js";
import { useParams } from "react-router-dom";

//#endregion

function LeaveCard() {
    //#region hooks
    const params = useParams()
    const { user } = useAuth()
    const { dataSourceHR } = useDataSource()
    const axiosPrivate = useAxiosPrivate(axiosHrPrivate)
    const screenSize = useScreenSize()
    const formRef = useRef()
    //#endregion

    //#region states
    const [formData, setFormData] = useState({
        employeeId: "",
        leaveInfoId: "",
        startDate: "",
        endDate: "",
        duration: 0,
        returnToWorkDate: "",
        explanation: "",
        address: "",
        standInEmployeeId: "",
        leaveStatusTypeId: leaveStatusTypes.autoApproved,
        id: "",
        leaveDates: [null, null]
    })
    const [readOnly, setReadOnly] = useState(false)
    const [dirty, setDirty] = useState(false)
    const [leaveInfo, setLeaveInfo] = useState()
    const [id, setId] = useState(params.id)
    const [dataLoading, setDataLoading] = useState(false)
    //#endregion

    const dbEmployes = useMemo(() => dataSourceHR({
        loadUrl: `/api/Employee/ComboList`,
        loadMode: "raw",

    }), [user])

    const dbLeaveType = useMemo(() => dataSourceHR({
        loadUrl: `/api/LeaveInfo`,
        loadMode: "raw"
    }), [user])

    const setReturnToWork = (startDate, endDate) => {
        (async function () {

            if (!startDate || !endDate)
                return null

            var params = { startDate, endDate }
            await axiosPrivate.get("/api/EmployeeLeave/ReturnToWork", { params })
                .then((response) => {
                    if (response?.status === 200) {
                        if (response.data?.data) {

                            setFormData((prev) => {
                                return {
                                    ...prev,
                                    duration: response.data.data.duration,
                                    returnToWorkDate: response.data.data.returnToWorkDate,
                                }
                            })
                        }
                    }
                })
                .catch((err) => console.log(err))

        })()

    }

    //#region handle events
    const handleFieldDataChanged = (e) => {
        setDirty(true)
    }

    const onValueChangedLeaveInfo = async (e) => {
        if (!e.value)
            return null;

        await axiosPrivate.get(`/api/LeaveInfo/${e.value}`
        ).then((response) => {
            if (response.status === 200 && response.data.data)
                setLeaveInfo(response.data.data)
        }
        ).catch((error) => { console.log("onValueChangedLeaveInfo error", error) })
    }
    const handleDateRangeValueChanged = (e) => {
                
        if (!dataLoading) {
            setFormData((prev) => {
                return {
                    ...prev,
                    leaveDates: [e.value[0], e.value[1]],
                    startDate: e.value[0],
                    endDate: e.value[1]
                }
            })
            setReturnToWork(e.value[0], e.value[1]);
        }
    }
    const handleStartDateValueChanged = (e) => {
        setReturnToWork(formData.startDate, formData.endDate);
    }

    const onAfterLoadData = (data) => {
        //iptal işleminde onValueChanged tetkileniyor..
        setFormData((prev) => {
            ///console.log(prev)
            return {
                ...prev,
                leaveDates: [prev.startDate, prev.endDate]
            }
        })
    }
    const onAfterSave = () => {
        // if (refreshGrid)
        //     refreshGrid()
    }

    //#endregion

    //#region editorOptions
    const employeEditorOptions = {
        dataSource: dbEmployes,
        ...getSelectBoxPropertiesIdText
    }
    const leaveInfoEditorOptions = {
        dataSource: dbLeaveType,
        ...getSelectBoxPropertiesIdName,
        onValueChanged: onValueChangedLeaveInfo
    }
    const startDateRangeBoxEditorOption = {
        showClearButton: true,
        useMaskBehavior: true,
        applyValueMode: "useButtons",
        dateSerializationFormat: "yyyy-MM-dd",
        onValueChanged: handleDateRangeValueChanged
    }
    const startDateTimeEditorOption = {
        type: "datetime",
        format: "shortDateShortTime",
        dateSerializationFormat: "yyyy-MM-ddTHH:mm:ss",
        useMaskBehavior: true,
        onValueChanged: handleStartDateValueChanged
    }
    const startTimeEditorOption = {
        type: "time",
        format: "shorttime",
    }

    const returnToWorkDateEditorOption = {
        type: "datetime",
        format: "shortDate",
        dateSerializationFormat: "yyyy-MM-ddTHH:mm:ss",
    }

    //#endregion

    return (
        <React.Fragment>
            <div className={'content-block'}>
                <div className={'dx-card responsive-paddings'}>

                    <BaseFormWithBreadCrumbs
                        formData={formData}
                        setFormData={setFormData}
                        formRef={formRef}
                        readOnly={readOnly}
                        setReadOnly={setReadOnly}
                        dirty={dirty}
                        setDirty={setDirty}
                        loadId={id}
                        loadUrl={"/api/EmployeeLeave/"}
                        updateUrl={"/api/EmployeeLeave/FormData"}
                        //toUpdateValues={toUpdateValues}
                        onAfterLoadData={onAfterLoadData}
                        onAfterSave={onAfterSave}
                        dataLoading={dataLoading}
                        setDataLoading={setDataLoading}
                    >
                        <Form
                            //width={600}
                            labelLocation={screenSize.isXSmall ? "top" : "left"}
                            formData={formData}
                            readOnly={readOnly}
                            onFieldDataChanged={handleFieldDataChanged}
                            ref={formRef}
                            width={500}
                        >
                            <GroupItem caption="İzin Kayıt İşlemi">
                                <SimpleItem
                                    dataField="employeeId"
                                    editorType="dxSelectBox"
                                    editorOptions={employeEditorOptions}>
                                    <Label text="Personel" />
                                    <RequiredRule />
                                </SimpleItem>
                                <SimpleItem
                                    dataField="leaveInfoId"
                                    editorType="dxSelectBox"
                                    editorOptions={leaveInfoEditorOptions}>
                                    <Label text="İzin Türü" />
                                    <RequiredRule />
                                </SimpleItem>

                                <Item dataField="leaveDates"
                                    editorType="dxDateRangeBox"
                                    editorOptions={startDateRangeBoxEditorOption}
                                    visible={leaveInfo?.leaveCalculationMethodId == leaveCalculationMethods.daily}
                                    name="leaveDates"
                                >
                                    <Label text="İzin Tarihleri" />
                                    <RequiredRule />
                                </Item>

                                <GroupItem  >
                                    <SimpleItem
                                        dataField="startDate"
                                        editorType="dxDateBox"
                                        editorOptions={startDateTimeEditorOption}
                                        visible={leaveInfo?.leaveCalculationMethodId == leaveCalculationMethods.hourly}
                                    >
                                        <Label text="Başlangıç Tarihi" />
                                        <RequiredRule />
                                    </SimpleItem>
                                    {/* <SimpleItem dataField="startDate" editorType="dxDateBox" editorOptions={startTimeEditorOption} >
                                <Label text="Başlangıç Saati" visible={false} />
                                <RequiredRule />
                            </SimpleItem> */}
                                </GroupItem>

                                <SimpleItem
                                    dataField="endDate"
                                    editorType="dxDateBox"
                                    editorOptions={startDateTimeEditorOption}
                                    visible={leaveInfo?.leaveCalculationMethodId == leaveCalculationMethods.hourly}

                                >
                                    <Label text="Bitiş Tarihi" />
                                    <RequiredRule />
                                </SimpleItem>
                                <SimpleItem dataField="duration" disabled="true">
                                    <Label text="İzin Süresi" />
                                    <RequiredRule />
                                </SimpleItem>
                                <SimpleItem dataField="returnToWorkDate"
                                    disabled={true}
                                    editorType="dxDateBox"
                                    editorOptions={returnToWorkDateEditorOption}
                                >
                                    <Label text="İşbaşı Tarihi" />
                                </SimpleItem>
                                <SimpleItem dataField="explanation">
                                    <Label text="Açıklama" />
                                    {leaveInfo?.isExplanationRequired && <RequiredRule />}
                                </SimpleItem>
                                <SimpleItem dataField="address" >
                                    <Label text="Adres" />

                                </SimpleItem>
                                <SimpleItem dataField="standInEmployeeId" editorType="dxSelectBox" editorOptions={employeEditorOptions} >
                                    <Label text="Yerine Bakacak Kişi" />
                                    {leaveInfo?.isStandInEmployeeRequired && <RequiredRule />}
                                </SimpleItem>

                                {/* isDocumentRequired */}
                            </GroupItem>

                        </Form>
                    </BaseFormWithBreadCrumbs>

                </div>
            </div>

        </React.Fragment >
    )
}

export default LeaveCard